const axios = require("axios");

var findThiSinhTTHocBa = async (payload) => {
	return await axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_TRUNGTUYEN}${process.env.VUE_APP_TIMTHISINHTTHB}`,
			{
				params: {
					soCmnd: payload.soCmnd,
					dotDangKyId: payload.dotDangKyId,
				},
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var findThiSinhTTTHPT = async (payload) => {
	return await axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_TRUNGTUYEN}${process.env.VUE_APP_TIMTHISINHTTTHPT}`,
			{
				params: {
					soCmnd: payload.soCmnd,
					sbd: payload.sbd,
				},
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var traCuu = (soCmnd) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_TRUNGTUYEN}${process.env.VUE_APP_TRACUU}`,
			{
				params: { soCmnd: soCmnd },
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var updateThongTin = (payload) => {
	let formFiles = new FormData();
	if (payload.fileAnh46)
		for (let i = 0; i < payload.fileAnh46.length; i++) {
			formFiles.append("fileAnh46", payload.fileAnh46[i]);
		}
	if (payload.fileBangTotNghiep)
		for (let i = 0; i < payload.fileBangTotNghiep.length; i++) {
			formFiles.append("fileBangTotNghiep", payload.fileBangTotNghiep[i]);
		}
	if (payload.fileKetQuaThi)
		for (let i = 0; i < payload.fileKetQuaThi.length; i++) {
			formFiles.append("fileKetQuaThi", payload.fileKetQuaThi[i]);
		}
	// formFiles.append("fileHocBa", payload.file);
	formFiles.append("jsonData", JSON.stringify(payload.trungtuyen));
	return axios.put(
		`${process.env.VUE_APP_API}${process.env.VUE_APP_TRUNGTUYEN}`, // phai truyen day du thong tin
		formFiles

	).then((response) => response)
		.catch((error) => error.response);
};


export const TrungTuyenService = {
	findThiSinhTTHocBa,
	findThiSinhTTTHPT,
	traCuu,
	updateThongTin,
};
